<div class="sticky-div">
	<app-patients-filter></app-patients-filter>
</div>
<div class="content">
	<table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)">

		<ng-container matColumnDef="id">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Id</th>
			<td mat-cell *matCellDef="let row">
				<div class="mrn sub">{{ row.id}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="first_name">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>First Name</th>
			<td mat-cell *matCellDef="let row">
				<div class="mrn sub">{{ row.first_name}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="last_name">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Last Name</th>
			<td mat-cell *matCellDef="let row">
				<div class="mrn sub">{{ row.last_name}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="birthdate">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>DOB</th>
			<td mat-cell *matCellDef="let row">
				<div class="mrn sub">{{ row.birthdate}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="email">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
			<td mat-cell *matCellDef="let row">
				<div class="mrn sub">{{ row.email}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="phone">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Phone</th>
			<td mat-cell *matCellDef="let row">
				<div class="mrn sub">{{ row.phone}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="zip_code">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Zip Code</th>
			<td mat-cell *matCellDef="let row">
				<div class="mrn sub">{{ row.zip_code}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="id_organization">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Org Id</th>
			<td mat-cell *matCellDef="let row">
				<div class="mrn sub">{{ row.id_organization}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="organization_name">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Org Name</th>
			<td mat-cell *matCellDef="let row">
				<div class="mrn sub">{{ row.organization_name}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="sex">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Sex</th>
			<td mat-cell *matCellDef="let row">
				<div class="mrn sub">{{ row.sex}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="race">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Race</th>
			<td mat-cell *matCellDef="let row">
				<div class="mrn sub">{{ row.race}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="ethnicity">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Ethnicity</th>
			<td mat-cell *matCellDef="let row">
				<div class="mrn sub">{{ row.ethnicity}}</div>
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="goto(row)">
		</tr>

	</table>

</div>
